import { Avatar, Button, DatePicker, Form, Input, Select, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  addKeyInArray,
  ArrayOption,
  pathLink,
} from "../../../helpers/siteConfig";
import {
  getAllUsersAsync,
  getCountUsersAsync,
} from "../../../store/features/NP/resource/resourceAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CustomTableProps } from "../../../types";
import {
  GetAllUsersData,
  GetAllUsersParams,
  TableData,
} from "../../../types/redux";
import { firstChar } from "../../../utils/string";
import { formatDate } from "../../../utils/time";
import CustomTable from "../../common/CustomTable";
import EditIcon from "../../../assets/icons/EditIcon";
import useModal from "../../../hooks/useModal";
import ConfirmModal from "../../common/ConfirmModal";
import AddIcon from "../../../assets/icons/AddIcon";
import {
  getAllAreaAsync,
  getAllRegionAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import {
  GetALLPOParams,
  GetAllSupplierData,
  SupplierGetAllParams,
} from "../../../types/redux/NP/supplier";
import {
  createPOAsync,
  getAllPOAsync,
  getAllSupplierAsync,
  getCountSupplierAsync,
} from "../../../store/features/NP/supplier/supplierAPI";
import EyeIcon from "../../../assets/icons/EyeIcon";
import { countParPageSerialNumber } from "../../../utils/number";

type Props = {
  keyword?: string;
} & CustomTableProps;

export const dbDateFormat = "YYYY-MM-DD";

export default function VendorTable({
  keyword = "",
  page,
  limit,
  isFirstPage,
  handlePagination,
  handleSetFirstPage,
}: Props) {
  const [regionId, setRegionId] = useState<string | undefined>(undefined);
  const [selectedVendorId, setSelectedVendorId] =
    useState<GetAllSupplierData | null>(null);
  const { regions } = useAppSelector((state) => state.npGeo);
  const { login } = useAppSelector((state) => state.login);
  const { postLoading, allSupplier, loading, supplierCount } = useAppSelector(
    (state) => state.supplier
  );

  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  // const { loading, allUsers, usersCount } = useAppSelector(
  //   (state) => state.resource,
  // );
  const {
    open: addPoOpen,
    toggle: addPoToggle,
    handleOpen: handleAddPoOpen,
  } = useModal();
  const location = useLocation();
  const path = pathLink(location.pathname, 1);

  const columns: ColumnsType<TableData<GetAllSupplierData>> = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Vendor Name",
      render: (val: GetAllSupplierData) => {
        return (
          <>
            <div>{val?.supplierName}</div>
          </>
        );
      },
    },

    {
      title: "Vendor ID",
      align: "center",
      render: (val: GetAllSupplierData) => {
        return (
          <>
            <div>{val?.vendorId ? val?.vendorId : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "Mobile",
      dataIndex: "contactNumber",
      align: "center",
      render: (val: GetAllSupplierData) => {
        if (!Array.isArray(val) || !val.length) return "N/A";
        const uniqueContacts = Array.from(new Set(val as string[]));
        return uniqueContacts.map((el: string) => <p key={el}>{el}</p>);
      },
    },

    {
      title: "Email Address",
      align: "center",
      dataIndex: "email",
      render: (val) => {
        return <>{val || "N/A"}</>;
      },
    },

    // {
    //   title: "Name",
    //   render: (val: GetAllSupplierData) => (
    //     <Space className="table_column_title" size={0} direction="horizontal">
    //       <Avatar size={45}>{firstChar(val?.supplierName)}</Avatar>
    //       {/* <Avatar src={IMG} size={44}></Avatar> */}
    //       <div className="ml-[8px]">
    //         <h5>{`${val?.supplierName} `}</h5>
    //         {/* <p className="mb-0.5">Email: {val?.email}</p> */}
    //         <p>
    //           Mobile:{" "}
    //           {Array.isArray(val?.contactNumber) &&
    //           val?.contactNumber.length > 0
    //             ? val.contactNumber[0]
    //             : "N/A"}
    //         </p>
    //       </div>
    //     </Space>
    //   ),
    // },
    // {
    //   title: "Status",
    //   align: "center",
    //   render: (val: GetAllUsersData) => <span>-</span>,
    // },

    // {
    //   title: "Total Minutes of Work (HH:MM)",
    //   align: "center",
    //   render: (val: GetAllUsersData) => (
    //     <span>{minutesToHours(val.totalMinutesOfWork || 0)} min</span>
    //   ),
    // },
    // {
    //   title: "Total Amount",
    //   align: "center",
    //   render: (val: GetAllUsersData) => <span>{val.totalAmount || 0} BDT</span>,
    // },
    // {
    //   title: "Total Rating",
    //   align: "center",
    //   render: (val: GetAllUsersData) => (
    //     <span>{fixedNumber(val?.rating / val?.numberOfTask)}</span>
    //   ),
    // },
    // {
    //   title: "Creation Date",
    //   align: "center",
    //   dataIndex: "createdAt",
    //   render: (val) => <span>{val ? formatDate(val) : "N/A"}</span>,
    // },
    // {
    //   title: "Payment Status",
    //   align: "center",
    //   render: (val: GetAllUsersData) => <span>-</span>,
    // },

    {
      title: "Action",
      align: "center",
      render: (val: GetAllSupplierData) => (
        <Space>
          {/* {login?.role === "energyOps" && (
            <Button
              className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]"
              onClick={() => {
                setSelectedVendorId(val);
                handleAddPoOpen({
                  type: "ADD_NEW_PO",
                });
              }}
            >
              <AddIcon color="#33AB29" />
              <span>Add PO</span>
            </Button>
          )} */}

          {login?.role === "edatco" && (
            <>
              <Link to={`/np/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>

              <Link to={`/np/vendor/edit/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EditIcon color="#33AB29" />
                  <span>Edit</span>
                </Button>
              </Link>
            </>
          )}

          {login?.role === "region" && (
            <>
              <Link to={`/regional/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>
            </>
          )}

          {login?.role === "finance" && (
            <>
              <Link to={`/finance/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>
            </>
          )}

          {login?.role === "gr" && (
            <>
              <Link to={`/gr-ops/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>
            </>
          )}

          {login?.role === "directorOps" && (
            <>
              <Link to={`/director-ops/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>
            </>
          )}

          {login?.role === "energyOps" && (
            <>
              <Link to={`/energy-ops/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>

              <Link to={`/energy-ops/vendor/edit/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EditIcon color="#33AB29" />
                  <span>Edit</span>
                </Button>
              </Link>
            </>
          )}

          {login?.role === "cluster" && (
            <>
              <Link to={`/cluster-ops/vendor/details/${val?._id}`}>
                <Button className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]">
                  <EyeIcon color="#33AB29" />
                  <span>View</span>
                </Button>
              </Link>
            </>
          )}
        </Space>
      ),
    },
  ];

  const onFinish = (values: any) => {
    const newValues = {
      vendor: selectedVendorId?._id,
      PONumber: values?.PONumber,
      region: values?.region,
      POIssuanceDate: values?.POIssuanceDate
        ? values?.POIssuanceDate.format(dbDateFormat)
        : undefined,
      carryForwardBalance: 0,
      initialMoney: values?.initialMoney,
    };

    dispatch(
      createPOAsync({
        data: newValues,
        others: {
          reRender,
        },
      })
    );
  };

  // redirect and re-render function
  const reRender = (val: boolean) => {
    if (val) {
      form.resetFields();
      addPoToggle();
      supplierData();
    }
  };

  const supplierData = useCallback(() => {
    const params: SupplierGetAllParams = {
      limit: limit,
      skip: limit * (page - 1),
    };

    const searchParams: SupplierGetAllParams = {
      supplierName: keyword,
    };

    if (
      login?.role === "finance" ||
      login?.role === "gr" ||
      login?.role === "directorOps" ||
      login?.role === "energyOps"
    ) {
      params.region = login?.region;
      searchParams.region = login?.region;
    }

    dispatch(
      getAllSupplierAsync({
        params: keyword ? searchParams : params,
      })
    );
  }, [dispatch, keyword, login?.region, login?.role, limit, page]);

  useEffect(() => {
    supplierData();
  }, [supplierData]);

  useEffect(() => {
    const params: GetAllUsersParams = {
      limit: limit,
      skip: limit * (page - 1),
      isPG: false,
      role: "finance",
    };

    const searchParams: GetAllUsersParams = {
      isPG: false,
      lastName: keyword,
      role: "finance",
    };

    if (path === "finance") {
      params.suppler = login?.suppler;
    }

    dispatch(
      getAllUsersAsync({
        params: keyword ? searchParams : params,
      })
    );
  }, [dispatch, keyword, limit, login?.suppler, page, path]);

  useEffect(() => {
    const params: any = {
      isPG: false,
      // role: "finance",
      lastName: keyword,
    };

    if (
      path === "finance" ||
      path === "gr-ops" ||
      path === "director-ops" ||
      path === "energy-ops"
    ) {
      params.suppler = login?.suppler;
      params.region = login?.region;
    }

    dispatch(
      getCountSupplierAsync({
        params,
      })
    );
  }, [dispatch, keyword, login?.suppler, login?.region, path]);

  useEffect(() => {
    if (keyword && isFirstPage) {
      handlePagination(1, 10);
      handleSetFirstPage(false);
    }
  }, [handlePagination, handleSetFirstPage, isFirstPage, keyword]);

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  return (
    <>
      {addPoOpen?.type === "ADD_NEW_PO" && (
        <ConfirmModal
          open={addPoOpen?.open}
          data={addPoOpen?.data}
          handleClose={addPoToggle}
          deleteLoading={loading}
          handleYes={() => {}}
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          buttonFooterBlank={true}
        >
          <div className="self-stretch text-center text-zinc-700 text-xl font-semibold mb-3">
            Add Monthly Credit
          </div>

          <Form
            form={form}
            layout="vertical"
            requiredMark="optional"
            onFinish={onFinish}
          >
            <Form.Item
              label="PO Number"
              name="PONumber"
              rules={[
                {
                  required: true,
                  message: "Please enter PO Number",
                },
                {
                  validator: async (_: any, value: string) => {
                    if (!value) return Promise.resolve();

                    const trimmedValue = value.trim();

                    // Alphanumeric only, no special characters, spaces, decimal, or negative signs
                    const validPattern = /^[a-zA-Z0-9]+$/;

                    if (!validPattern.test(trimmedValue)) {
                      return Promise.reject(
                        new Error(
                          "PO Number must contain only letters and numbers without special characters, spaces, or decimals"
                        )
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              style={{ marginBottom: 12 }}
            >
              <Input placeholder="PO Number" allowClear />
            </Form.Item>

            <Form.Item
              label="PO Issuance Date"
              name="POIssuanceDate"
              rules={[
                { required: true, message: "Please select PO Issuance Date" },
              ]}
              style={{ marginBottom: 12 }}
            >
              <DatePicker
                format="YYYY-MM-DD"
                className="w-full"
                placeholder="Select PO Issuance Date"
              />
            </Form.Item>

            <Form.Item
              label="PO Amount"
              name="initialMoney"
              rules={[
                {
                  required: true,
                  message: "Please enter PO Amount",
                },
                {
                  validator: async (_: any, value: string) => {
                    if (!value) return Promise.resolve();

                    const trimmedValue = value.trim();

                    // If value contains a decimal point
                    if (trimmedValue.includes(".")) {
                      return Promise.reject(
                        new Error("Decimal points are not allowed")
                      );
                    }

                    // Check if it's a positive whole number
                    if (!/^\d+$/.test(trimmedValue)) {
                      return Promise.reject(
                        new Error("PO Amount must be a positive whole number")
                      );
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              style={{ marginBottom: 12 }}
            >
              <Input placeholder="PO Amount" allowClear />
            </Form.Item>

            <Form.Item
              label="Zone"
              name="region"
              rules={[{ required: true, message: "Please select a Zone" }]}
              style={{ marginBottom: 12 }}
            >
              <Select
                value={regionId}
                placeholder="Select cluster"
                allowClear
                showSearch
                options={ArrayOption(regions, "regionName", "_id", true)}
                className="min-w-[120px]"
              />
            </Form.Item>

            <div className="w-full justify-end flex gap-2 pt-6">
              <Button onClick={() => addPoToggle()} className="cancel_btn">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" loading={postLoading}>
                Add Now
              </Button>
            </div>
          </Form>
        </ConfirmModal>
      )}

      <CustomTable<TableData<GetAllUsersData>>
        loading={loading}
        total={supplierCount}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        dataList={addKeyInArray(allSupplier)}
        isPagination={keyword ? false : true}
      />
    </>
  );
}
